// ======================================================================
// File Name       : contentDistribution
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as actionTypes from '../../constants/ActionTypes';
import * as contentDistributionActionTypes from '../../constants/actionTypes/contentDistribution';

export function receiveContentDistributionServiceName(data) {
  return {
    type: contentDistributionActionTypes.CONTENT_DISTRIBUTION_REGISTER_SERVICE_NAME,
    data,
  };
}

export function receiveContentDistributionContentList(data) {
  return {
    type: contentDistributionActionTypes.CONTENT_DISTRIBUTION_REGISTER_GET_CONTENT_LIST,
    data,
  };
}

export function receiveContentDistributionCourseList(data) {
  return {
    type: contentDistributionActionTypes.CONTENT_DISTRIBUTION_REGISTER_GET_COURSE_LIST,
    data,
  };
}

export function updateContentDistributionList(dataList, recordNum) {
  return {
    type: contentDistributionActionTypes.OFFER_LIST_UPDATE_CONTENT_LIST,
    dataList,
    recordNum,
  };
}

export function updateCourseDistributionList(dataList, recordNum) {
  return {
    type: contentDistributionActionTypes.OFFER_LIST_UPDATE_COURSE_LIST,
    dataList,
    recordNum,
  };
}

export function recieveSaveDistributionSuccess(data) {
  return {
    type: contentDistributionActionTypes.CONTENT_DISTRIBUTION_SAVE_SUCCESS,
    data,
  };
}

export function localSorted(data) {
  return {
    type: contentDistributionActionTypes.CONTENT_DISTRIBUTION_REGISTER_LOCAL_SORT,
    data,
  };
}

export function resetDataDistributionOfferListEdit() {
  return {
    type: contentDistributionActionTypes.CONTENT_DISTRIBUTION_REGISTER_RESET,
  };
}

export function localPagingContentDistributionList(startPosition) {
  return {
    type: contentDistributionActionTypes.CONTENT_DISTRIBUTION_REGISTER_LOCAL_PAGING,
    startPosition,
  };
}


export function receiveOfferListSearchContentResult(contentResult) {
  return {
    type: actionTypes.CONTENT_DISTRIBUTION_CONTENTS_LIST,
    contentResult,
  };
}

export function receiveOfferListSearchCourseResult(courseResult) {
  return {
    type: actionTypes.CONTENT_DISTRIBUTION_COURSE_LIST,
    courseResult,
  };
}

export function receiveEditContents() {
  return {
    type: actionTypes.CONTENT_DISTRIBUTION_EDIT_CONTENT,
  };
}

export function receiveData(resData, type) {
  return {
    type,
    resData,
  };
}

export function receiveFileList({ recordNum, importResultList }) {
  return {
    type: actionTypes.RECEIVED_CONTENT_DISTRIBUTION_FILE_LIST,
    recordNum,
    importResultList,
  };
}

export function downloadFormResponse(camelizeJson) {
  return {
    type: actionTypes.CONTENT_DISTRIBUTION_USAGE,
    contentDistributionUsage: camelizeJson,
  };
}

export function distributionCourseUsage(result) {
  return {
    type: actionTypes.COURSE_DISTRIBUTION_USAGE,
    courseDistributionUsage: result,
  };
}

export function receiveDistributionServiceDeleteResult(deleteResult) {
  return {
    type: actionTypes.CONTENT_DISTRIBUTION_SERVICE_DELETE_RESULT,
    deleteResult,
  };
}

export function resetDistributionOfferListDetail() {
  return {
    type: actionTypes.CONTENT_DISTRIBUTION_OFFER_LIST_DETAIL_RESET,
  };
}

export function receiveContentListToEdit(data) {
  return {
    type: contentDistributionActionTypes.GET_CONTENT_DISTRIBUTION_OFFER_LIST,
    data,
  };
}

export function receiveGetCourseDistributionList(data) {
  return {
    type: contentDistributionActionTypes.GET_CONTENT_DISTRIBUTION_COURSE_LIST,
    data,
  };
}
